export const KeywordAdCustomizerAttribute = {
  parent: 'Keyword',
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'Keyword AdCustomizer Attribute',
    },
    AdCustomizerAttributeValue: {
      'bulk-upload-header': 'AdCustomizer AttributeValue',
    },
  },
};
